import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll<HTMLElement>("[data-slider-class]");

  sliders.forEach((sliderElement) => {
    const slideCount = sliderElement.querySelectorAll(".splide__slide").length;

    let defaultPerPage = 2;
    if (sliderElement.clientWidth > 1239) {
      defaultPerPage = 3;
    }

    if (slideCount < defaultPerPage) {
      defaultPerPage = slideCount;
    }

    // Klassenzustände abhängig von Slide-Anzahl
    if (slideCount <= defaultPerPage) {
      sliderElement.classList.add("no-slider-needed");
    }
    if (slideCount <= 1) {
      sliderElement.classList.add("only-one-slide");
    }
    if (slideCount === 2) {
      sliderElement.classList.add("only-two-slide");
    }

    new Splide(sliderElement, {
      type: "slide",
      perPage: defaultPerPage,
      perMove: 1,
      gap: "20px",
      arrows: true,
      pagination: false,
      breakpoints: {
        910: {
          perPage: Math.min(1, slideCount),
        },
        1400: {
          perPage: Math.min(2, slideCount),
        },
      },
    }).mount();
  });
});
